module.exports = __webpack_public_path__ + "static/media/16c-02_Pasaje-1-2016-405x295mm-oleo-sobre-papel.086b201b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16c/16c-02_Pasaje-1-2016-405x295mm-oleo-sobre-papel.jpg
// module id = 193
// module chunks = 0